import { JiraProductDiscoveryLogo } from '@atlaskit/logo';

import { FormattedMessage, defineMessage } from 'react-intl';

import { type JSX } from 'react/jsx-runtime';

import { defineContent, type DefinedContent } from '@post-office/define-content';

export const CCP_PRODUCT_ID = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';

export const HAMS_PRODUCT_ID = 'jira-product-discovery';

export const PRODUCT_NAME = 'Jira Product Discovery';

export const registeredContent: DefinedContent<{
	default: ['appName', 'description'];
	template: ['appName', 'description'];
}> = defineContent({
	default: {
		appName: {
			id: 'growth.recommendation-jpd.app-switcher-discovery-section.app-name',
			defaultMessage: 'Jira Product Discovery',
			description:
				'Product name for the Jira Product Discovery recommendation in the app switcher discovery section',
			role: 'title',
		},
		description: {
			id: 'growth.recommendation-jpd.value-proposition',
			description: 'Description of the product value proposition',
			defaultMessage: 'Prioritize, collaborate, and deliver new ideas',
			role: 'description',
		},
	},
	template: {
		appName: {
			id: 'growth.recommendation-jpd.app-switcher-discovery-section.template-name',
			defaultMessage: 'Product roadmap',
			description:
				'Template name for the Jira Product Discovery roadmap recommendation in the app switcher discovery section',
			role: 'title',
		},
		description: {
			id: 'growth.recommendation-jpd-product-roadmap.value-proposition',
			description: 'Description of the product value proposition',
			defaultMessage: 'Align everyone with custom roadmaps',
			role: 'description',
		},
	},
});

export const PRODUCT_DESCRIPTION: JSX.Element = (
	<FormattedMessage {...registeredContent.default.description} />
);

// go/trailblazers
// TBLZ-858 Product Store - Personal Use Case
export const PRODUCT_LOGO_COMPONENT: JSX.Element = (
	<JiraProductDiscoveryLogo appearance={'brand'} />
);

export const PRODUCT_HEADING: JSX.Element = (
	<FormattedMessage
		id="growth.recommendation-jpd.product-heading"
		description="Description of the product"
		defaultMessage="Build the right features, the right way"
	/>
);

export const PRODUCT_SUBHEADING: JSX.Element = (
	<FormattedMessage
		id="growth.recommendation-jpd.product-subheading"
		description="Extra information about the product"
		defaultMessage="Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."
	/>
);

export const PRODUCT_IMAGE_ALT_TEXT: {
	id: string;
	description: string;
	defaultMessage: string;
} = defineMessage({
	id: 'growth.recommendation-jpd.product-alt-text',
	description: 'Alt text for the product image',
	defaultMessage:
		'Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea.',
});

// Template-specific constants
export const JPD_TEMPLATE_ROADMAP = 'jpd.product-roadmap';

export const JPD_TEMPLATE_SELECTOR_KEY_ROADMAP = 'roadmap';

export const JPD_TEMPLATE_ROADMAP_NAME = 'Product roadmap';

export const JPD_TEMPLATE_ROADMAP_DESCRIPTION: JSX.Element = (
	<FormattedMessage {...registeredContent.template.description} />
);
